import { uid } from "@xbs/lib-state";
export default function (store, ev) {
    const { id, project } = ev;
    if (store.existsProject(id))
        return;
    if (!ev.$meta) {
        ev.$meta = {};
    }
    ev.$meta.branchId = "$allBranches";
    const projects = [
        ...store.getState().projects,
        {
            id: id ?? uid().toString(),
            label: "New project",
            ...project,
        },
    ];
    store.setState({ projects });
    return () => {
        store.in.exec("delete-project", {
            id,
            $meta: { skipHistory: true, branchId: "$allBranches" },
        });
    };
}
//# sourceMappingURL=add.js.map